export default {
  com_all: 'All',
  com_upcoming_only: 'Planned',
  com_live: 'Active',
  com_closed: 'Completed',
  com_search: 'Search crowdfunding campaign',
  com_sort_launch_date: 'Launch date',
  com_sort_soonest: 'Ending soonest',
  com_sort_popularity: 'Popularity',
  com_no_sales_found: 'We did not find any campaigns with a similar name',
  com_no_sales_found_desc: 'Check spelling, try searching by asset code or use filters',
  com_state_as_status: 'State',
  com_name: 'Company name',
  com_date_of_foundation: 'Date of foundation',
  com_homepage: 'Homepage',
  com_industry_tags: 'Industry / Tags',
  com_team_size: 'Team size',
  com_type: 'Company type',
  com_headquarters: 'Headquarters',
  com_email: 'Company email',
  com_website: 'Company website',
  com_earned: 'Earned',
  com_target: 'Collection purpose',
  com_profitability: 'Profitability',
  com_investors: 'Investors',
  com_campaign: 'Campaign'
}



// WEBPACK FOOTER //
// ./src/js/i18n/views/company_view.js